export const MY_BETS_TABS = [
  { value: 'tickets', label: 'Tickets' },
  { value: 'open', label: 'Open bets' },
  { value: 'settled', label: 'Settled bets' },
  { value: 'subscriptions', label: 'Subscriptions' },
];

export const PAGE_LIMIT = 8;
